<template> 
    <tr>
        <td> {{ this.rigaContratti.CodiceContratto }} </td>
        <td> {{ this.formatDateNoOre(this.rigaContratti.DataContratto) }} </td>
        <td> {{ this.rigaContratti.Stato }} </td>
        <td> {{ this.rigaContratti.Descrizione }} </td>
        <td> {{ this.formatDateNoOre(this.rigaContratti.DataInizioValidita) }} </td>
        <td> {{ this.formatDateNoOre(this.rigaContratti.DataFineValidita) }} </td>
        <td> {{this.rigaContratti.DescrSiti ?? " - "}} </td>
        <td> {{ this.rigaContratti.TipoScadenza ?? " - " }} </td>
        <td>{{this.rigaContratti.Revisione }}</td>
    </tr>
</template>

<script>
import {dateMixin} from "/mixin.js";

export default {
    name: "RigaGrigliaContratti",
    props: {
        rigaContratti: Object
    }, 
    mixins:[dateMixin]
} 
</script>